import * as Views from "./views";

const Module = {
    name: "cashflowattributionrulegroups",
    defaultRoutePath: "/cashflows/cashflowattributionrulegroup",
    menuItemScope: "cashflows",
    menuItemName: "cashflowattributionrulegroups",
    routes: [
        {
            path: "/cashflows/cashflowattributionrulegroup",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Views.Create,
        },
    ],

}

export default Module;
